import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const Item = ({ data, variation }) => {
  const { heading, subHeading, text, columnWidth } = data;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderSubHeading = !!subHeading?.value;
  const shouldRenderText = !!text?.value;

  const renderVariation = () => {
    if (variation === 'titleWithTwoEqualColumns'.toLowerCase()) {
      return (
        <div
          className={`col-12 col-md-${
            columnWidth?.fields?.DropdownValue?.value || 4
          } taxonomy-item`}
        >
          {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
        </div>
      );
    } else if (variation === 'titleWithFourTextBlocks'.toLowerCase()) {
      return (
        <div className="col-12 col-md-4 taxonomy-item">
          {shouldRenderSubHeading && (
            <div className="taxonomy-subheading">
              <Text field={subHeading} />
            </div>
          )}
          {shouldRenderHeading && (
            <h4 className="taxonomy-heading">
              <Text field={heading} />
            </h4>
          )}
          {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
        </div>
      );
    } else if (variation === 'titleWithSubTitleAndTwoEqualColumns'.toLowerCase()) {
      return (
        <div className="col-12 col-md-6 taxonomy-item">
          {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
        </div>
      );
    } else if (variation === 'withImages'.toLowerCase()) {
      return (
        <>
          <div className="col-1 col-md-6 taxonomy-item"></div>
          <div className="col-11 col-md-5 taxonomy-item">
            {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
          </div>
        </>
      );
    } else if (variation === 'titleWithThreeEqualColumns'.toLowerCase()) {
      return (
        <div className="col-12 col-md-4 taxonomy-item">
          {shouldRenderHeading && (
            <h4 className="taxonomy-heading">
              <Text field={heading} />
            </h4>
          )}
          {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
        </div>
      );
    } else if (variation === 'titleWithTwoUnEqualColumns'.toLowerCase()) {
      return (
        <div className="col-12 taxonomy-item">
          {shouldRenderHeading && (
            <h4 className="taxonomy-heading">
              <Text field={heading} />
            </h4>
          )}
          {shouldRenderText && <RichText field={text} className="taxonomy-text" />}
        </div>
      );
    } else if (variation === 'onlyTitleAndSubTitle'.toLowerCase()) {
    } else {
      return null;
    }
  };

  return renderVariation();
};

export default Item;
